<template>
  <div class="employee-detail">
    <aside class="employee-detail__identity">
      <div class="employee-detail__photo">
        <img :src="data.photo || defaultPhoto" :alt="'Foto ' + (data.name || 'karyawan')" @load="onImageLoad()" @error="setDefaultPhoto">
        <button type="button" class="employee-detail__photo-edit" aria-label="Ubah data karyawan" @click="$router.push({ path: '/human-resource/employee/edit/'+data.id })">
          <i class="fas fa-pen"></i>
        </button>
      </div>
      <h2>{{ data.name || 'Nama belum tersedia' }}</h2>
      <p>{{ data.position_name || 'Jabatan belum ditentukan' }}</p>
      <nav class="employee-detail__navigation" aria-label="Navigasi profil karyawan">
        <button type="button" class="employee-detail__nav-item is-active"><i class="fas fa-user"></i><span>Informasi personal</span></button>
        <button type="button" class="employee-detail__nav-item" @click="$router.push({ path: '/human-resource/employee/edit/'+data.id })"><i class="fas fa-user-edit"></i><span>Ubah data</span></button>
        <button type="button" class="employee-detail__nav-item" @click="$router.push({ path: '/human-resource/employee/list' })"><i class="fas fa-arrow-left"></i><span>Daftar karyawan</span></button>
      </nav>
    </aside>

    <section class="employee-detail__content">
      <div class="employee-detail__section-heading">
        <div>
          <span class="employee-detail__eyebrow">Profil karyawan</span>
          <h3>Informasi personal</h3>
          <p>Data pribadi, kontak, dan penempatan karyawan.</p>
        </div>
      </div>

      <dl class="employee-detail__grid">
        <div class="employee-detail__item">
          <dt>Nomor karyawan</dt>
          <dd><i class="fas fa-id-badge"></i>{{ displayValue(data.employee_number_id) }}</dd>
        </div>
        <div class="employee-detail__item">
          <dt>Nama lengkap</dt>
          <dd><i class="fas fa-user"></i>{{ displayValue(data.name) }}</dd>
        </div>
        <div class="employee-detail__item employee-detail__item--wide">
          <dt>Email</dt>
          <dd><i class="fas fa-envelope"></i>{{ displayValue(data.email) }}</dd>
        </div>
        <div class="employee-detail__item">
          <dt>Nomor telepon</dt>
          <dd><i class="fas fa-phone-alt"></i>{{ displayValue(data.mobile_phone || data.phone) }}</dd>
        </div>
        <div class="employee-detail__item">
          <dt>Tempat, tanggal lahir</dt>
          <dd><i class="fas fa-calendar-alt"></i>{{ birthInformation }}</dd>
        </div>
        <div class="employee-detail__item">
          <dt>Departemen</dt>
          <dd><i class="fas fa-building"></i>{{ displayValue(data.department_name) }}</dd>
        </div>
        <div class="employee-detail__item">
          <dt>Jabatan</dt>
          <dd><i class="fas fa-briefcase"></i>{{ displayValue(data.position_name) }}</dd>
        </div>
        <div class="employee-detail__item employee-detail__item--wide">
          <dt>Alamat</dt>
          <dd><i class="fas fa-map-marker-alt"></i>{{ displayValue(data.address) }}</dd>
        </div>
      </dl>

      <div class="employee-detail__actions">
      <button @click="$router.push({ path: '/human-resource/employee/list' })" class="btn btn-outline-primary"><i class="fas fa-arrow-left mr-2"></i> Kembali</button>
      <button
        @click="$router.push({ path: '/human-resource/employee/edit/'+data.id })"
        class="btn btn-primary"
        v-if="manipulateBtn == true"
      ><i class="far fa-fw fa-edit"></i> Edit</button>
      <button
        @click="deleteData(data.id)"
        class="btn btn-light-danger"
        v-if="manipulateBtn == true"
      ><i class="far fa-fw fa-trash-alt"></i> Hapus</button>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment'
import module from '@/core/modules/CrudModule.js'
export default {

  name: 'Detail',

  data() {
    return {
      imgLoaded: false,
      manipulateBtn:false,
      defaultPhoto: '/images/default-profile.svg'
    }
  },

  methods: {
    displayValue(value){
      return value || '—'
    },
    date(date){
      return moment(date).format('DD-MM-YYYY')
    },
    onImageLoad() {
      this.imgLoaded = true
    },
    setDefaultPhoto(event) {
      if (!event.target.src.endsWith(this.defaultPhoto)) {
        event.target.src = this.defaultPhoto
      }
    },
    async deleteData(id) {
      // Delete Data
      let result = await module.delete('employees/' + id)
      // If Deleted
      if (result) {
        this.$router.push({path: '/human-resource/employee/list'})
      }
    },

    // access management
    async setActiveMenu(){

     let access_right_user = window.localStorage.getItem("access_right_display")
     let access_right = JSON.parse(access_right_user) || []
    
    let a
    for(a = 0; a < access_right.length; a++){
      
      
      if(access_right[a] == "7002"){
        this.manipulateBtn = true
      }
      
    }
    },

  },

  computed: {
    birthInformation(){
      const place = this.data.birt_place || ''
      const birthDate = this.data.birt_date ? this.date(this.data.birt_date) : ''
      return [place, birthDate].filter(Boolean).join(', ') || '—'
    }
  },

  props: {
    data: Object,
  },

  mounted(){
    this.setActiveMenu()
  }

}
</script>

<style>
</style>
